import { reactive, ref } from "vue";

const swan700List = [
    {
        label: 'Swan 700',
        value: 'TE700',
        letter: 'A',
    },
    {
        label: 'Swan 710E',
        value: 'TE710E',
        letter: 'A',
    },
    {
        label: 'Swan 720E',
        value: 'TE720E',
        letter: 'A',
    },
    {
        label: 'Swan 710S',
        value: 'TE710S',
        letter: 'A',
    },
    {
        label: 'Swan 720S',
        value: 'TE720S',
        letter: 'A',
    },
    {
        label: 'Swan 750M',
        value: 'TE750M',
        letter: 'A',
    },
    {
        label: 'Swan 760M',
        value: 'TE760M',
        letter: 'A',
    },
];

const swan700PList = [
    {
        label: 'Swan 700P',
        value: 'TE700P',
        letter: 'B',
    },
    {
        label: 'Swan 730E',
        value: 'TE730E',
        letter: 'B',
    },
    {
        label: 'Swan 760E',
        value: 'TE760E',
        letter: 'B',
    },
    {
        label: 'Swan 730S',
        value: 'TE730S',
        letter: 'B',
    },
    {
        label: 'Swan 750S',
        value: 'TE750S',
        letter: 'B',
    },
    {
        label: 'Swan 760S',
        value: 'TE760S',
        letter: 'B',
    },
    {
        label: 'Swan 770M',
        value: 'TE770M',
        letter: 'B',
    },
    {
        label: 'Swan 780M',
        value: 'TE780M',
        letter: 'B',
    },
    {
        label: 'Swan 790M',
        value: 'TE790M',
        letter: 'B',
    },
];

const swan600List = [
    {
        label: 'Swan 600',
        value: 'TE600',
        letter: 'A',
    },
    {
        label: 'Swan 610E',
        value: 'TE610E',
        letter: 'A',
    },
    {
        label: 'Swan 620E',
        value: 'TE620E',
        letter: 'A',
    },
    {
        label: 'Swan 610S',
        value: 'TE610S',
        letter: 'A',
    },
    {
        label: 'Swan 620S',
        value: 'TE620S',
        letter: 'A',
    },
    {
        label: 'Swan 650M',
        value: 'TE650M',
        letter: 'A',
    },
    {
        label: 'Swan 660M',
        value: 'TE660M',
        letter: 'A',
    },
];

const swan600PList = [
    {
        label: 'Swan 600P',
        value: 'TE600P',
        letter: 'B',
    },
    {
        label: 'Swan 630E',
        value: 'TE630E',
        letter: 'B',
    },
    {
        label: 'Swan 660E',
        value: 'TE660E',
        letter: 'B',
    },
    {
        label: 'Swan 630S',
        value: 'TE630S',
        letter: 'B',
    },
    {
        label: 'Swan 650S',
        value: 'TE650S',
        letter: 'B',
    },
    {
        label: 'Swan 660S',
        value: 'TE660S',
        letter: 'B',
    },
    {
        label: 'Swan 670M',
        value: 'TE670M',
        letter: 'B',
    },
    {
        label: 'Swan 680M',
        value: 'TE680M',
        letter: 'B',
    },
    {
        label: 'Swan 690M',
        value: 'TE690M',
        letter: 'B',
    },
]

// 天龙800系列
const TL800list = [
    // B系列
    {
        label: '天龙890M',
        value: 'TL890M',
        letter: 'B',
    },
    {
        label: '天龙880M',
        value: 'TL880M',
        letter: 'B',
    },
    {
        label: '天龙870M',
        value: 'TL870M',
        letter: 'B',
    },
    {
        label: '天龙860S',
        value: 'TL860S',
        letter: 'B',
    },
    {
        label: '天龙850S',
        value: 'TL850S',
        letter: 'B',
    },
    {
        label: '天龙830S',
        value: 'TL830S',
        letter: 'B',
    },
    {
        label: '天龙860E',
        value: 'TL860E',
        letter: 'B',
    },
    {
        label: '天龙830E',
        value: 'TL830E',
        letter: 'B',
    },
    // A系列
    {
        label: '天龙860M',
        value: 'TL860M',
        letter: 'A',
    },
    {
        label: '天龙850M',
        value: 'TL850M',
        letter: 'A',
    },
    {
        label: '天龙820S',
        value: 'TL820S',
        letter: 'A',
    },
    {
        label: '天龙810S',
        value: 'TL810S',
        letter: 'A',
    },
    {
        label: '天龙820E',
        value: 'TL820E',
        letter: 'A',
    },
    {
        label: '天龙810E',
        value: 'TL810E',
        letter: 'A',
    },
];

const TD900List = [
    // B系列
    {
        label: '天龙990M',
        value: 'TD990M',
        letter: 'B',
    },
    {
        label: '天龙980M',
        value: 'TD980M',
        letter: 'B',
    },
    {
        label: '天龙970M',
        value: 'TD970M',
        letter: 'B',
    },
    {
        label: '天龙960S',
        value: 'TD960S',
        letter: 'B',
    },
    {
        label: '天龙950S',
        value: 'TD950S',
        letter: 'B',
    },
    {
        label: '天龙930S',
        value: 'TD930S',
        letter: 'B',
    },
    {
        label: '天龙960E',
        value: 'TD960E',
        letter: 'B',
    },
    {
        label: '天龙930E',
        value: 'TD930E',
        letter: 'B',
    },
    // A系列
    {
        label: '天龙960M',
        value: 'TD960M',
        letter: 'A',
    },
    {
        label: '天龙950M',
        value: 'TD950M',
        letter: 'A',
    },
    {
        label: '天龙920S',
        value: 'TD920S',
        letter: 'A',
    },
    {
        label: '天龙910S',
        value: 'TD910S',
        letter: 'A',
    },
    {
        label: '天龙920E',
        value: 'TD920E',
        letter: 'A',
    },
    {
        label: '天龙910E',
        value: 'TD910E',
        letter: 'A',
    },
];

// 天鹅
const SWANList = [
    {
        label: "天鹅600",
        value: 'TE600',
        letter: "A",
    },
    {
        label: "天鹅600P",
        value: 'TE600P',
        letter: "B",
    },
    {
        label: "天鹅600E",
        value: 'TE600E',
        letter: "B",
    },
    {
        label: "天鹅600S",
        value: 'TE600S',
        letter: "A",
    },
    {
        label: "天鹅600M",
        value: 'TE600M',
        letter: "A",
    },
    {
        label: "天鹅600H",
        value: 'TE600H',
        letter: "B",
    },
    {
        label: "天鹅600L",
        value: 'TE600L',
        letter: "A",
    },
    {
        label: "天鹅600T",
        value: 'TE600T',
        letter: "B",
    },
];

const YAGList = [
    {
        label: "BP-E06",
        value: 'BP-E06',
        letter: "",
    },
]

const EYESPAList = [
    {
        label: "EYE",
        value: 'EYE',
        letter: "",
    },
]

const LanWList = [
    {
        label: "蓝鲸110",
        value: 'LanW110',
        letter: "A",
    },
    {
        label: "蓝鲸120",
        value: 'LanW120',
        letter: "A",
    },
    {
        label: "蓝鲸130",
        value: 'LanW130',
        letter: "A",
    },
]

// 350S/330S/320S/310S
// 350E/330E/320E/310E
// 390M/380M/370M/360M
// 天鸽
const COLUMBAList = [
    {
        label: "筛查箱310",
        value: 'SCX310',
        letter: "B",
    },
    {
        label: "筛查箱310S",
        value: 'SCX310S',
        letter: "A",
    },
    {
        label: "天鸽300",
        value: 'TG300',
        letter: "A",
    },
    {
        label: "天鸽300S",
        value: 'TG300S',
        letter: "A",
    },
    {
        label: '天鸽310S',
        value: 'TG310S',
        letter: "A",
    },
    {
        label: '天鸽310E',
        value: 'TG310E',
        letter: "A",
    },
    {
        label: '天鸽320S',
        value: 'TG320S',
        letter: "A",
    },
    {
        label: '天鸽320E',
        value: 'TG320E',
        letter: "A",
    },
    {
        label: '天鸽330S',
        value: 'TG330S',
        letter: "A",
    },
    {
        label: '天鸽330E',
        value: 'TG330E',
        letter: "A",
    },
    {
        label: '天鸽350S',
        value: 'TG350S',
        letter: "A",
    },
    {
        label: '天鸽350E',
        value: 'TG350E',
        letter: "A",
    },
    {
        label: '天鸽360M',
        value: 'TG360M',
        letter: "A",
    },
    {
        label: '天鸽370M',
        value: 'TG370M',
        letter: "A",
    },
    {
        label: '天鸽380M',
        value: 'TG380M',
        letter: "A",
    },
    {
        label: '天鸽390M',
        value: 'TG390M',
        letter: "A",
    },
];

const TH700LIST = [
    {
        label: "天鹤710E",
        value: 'TH710E',
        letter: "A",
    },
    {
        label: "天鹤720E",
        value: 'TH720E',
        letter: "A",
    },
    {
        label: "天鹤730E",
        value: 'TH730E',
        letter: "A",
    },
    {
        label: "天鹤760E",
        value: 'TH760E',
        letter: "A",
    },
    {
        label: "天鹤710S",
        value: 'TH710S',
        letter: "A",
    },
    {
        label: "天鹤720S",
        value: 'TH720S',
        letter: "A",
    },
    {
        label: "天鹤730S",
        value: 'TH730S',
        letter: "A",
    },
    {
        label: "天鹤750S",
        value: 'TH750S',
        letter: "A",
    },
    {
        label: "天鹤760S",
        value: 'TH760S',
        letter: "A",
    },
    {
        label: "天鹤750M",
        value: 'TH750M',
        letter: "A",
    },
    {
        label: "天鹤760M",
        value: 'TH760M',
        letter: "A",
    },
    {
        label: "天鹤770M",
        value: 'TH770M',
        letter: "A",
    },
    {
        label: "天鹤780M",
        value: 'TH780M',
        letter: "A",
    },
    {
        label: "天鹤790M",
        value: 'TH790M',
        letter: "A",
    },
]


const TY600LIST = [
    {
        label: "天鹰610S",
        value: 'TY610S',
        letter: "A",
    },
    {
        label: "天鹰620S",
        value: 'TY620S',
        letter: "A",
    },
    {
        label: "天鹰630S",
        value: 'TY630S',
        letter: "A",
    },
    {
        label: "天鹰650S",
        value: 'TY650S',
        letter: "A",
    },
    {
        label: "天鹰660S",
        value: 'TY660S',
        letter: "A",
    },
    {
        label: "天鹰661S",
        value: 'TY661S',
        letter: "A",
    },
    {
        label: "天鹰650M",
        value: 'TY650M',
        letter: "A",
    },
    {
        label: "天鹰660M",
        value: 'TY660M',
        letter: "A",
    },
    {
        label: "天鹰670M",
        value: 'TY670M',
        letter: "A",
    },
    {
        label: "天鹰680M",
        value: 'TY680M',
        letter: "A",
    },
    {
        label: "天鹰690M",
        value: 'TY690M',
        letter: "A",
    },
];

const TY700LIST = [
    {
        label: "天鹰710S",
        value: 'TY710S',
        letter: "B",
    },
    {
        label: "天鹰720S",
        value: 'TY720S',
        letter: "B",
    },
    {
        label: "天鹰730S",
        value: 'TY730S',
        letter: "B",
    },
    {
        label: "天鹰750S",
        value: 'TY750S',
        letter: "B",
    },
    {
        label: "天鹰760S",
        value: 'TY760S',
        letter: "B",
    },
    {
        label: "天鹰761S",
        value: 'TY761S',
        letter: "B",
    },
    {
        label: "天鹰750M",
        value: 'TY750M',
        letter: "B",
    },
    {
        label: "天鹰760M",
        value: 'TY760M',
        letter: "B",
    },
    {
        label: "天鹰770M",
        value: 'TY770M',
        letter: "B",
    },
    {
        label: "天鹰780M",
        value: 'TY780M',
        letter: "B",
    },
    {
        label: "天鹰790M",
        value: 'TY790M',
        letter: "B",
    },
];

const TC600LIST = [
    {
        label: "天鹿610S",
        value: 'TC610S',
        letter: "A",
    },
    {
        label: "天鹿620S",
        value: 'TC620S',
        letter: "A",
    },
    {
        label: "天鹿630S",
        value: 'TC630S',
        letter: "A",
    },
    {
        label: "天鹿650S",
        value: 'TC650S',
        letter: "A",
    },
    {
        label: "天鹿660S",
        value: 'TC660S',
        letter: "A",
    },
    {
        label: "天鹿650M",
        value: 'TC650M',
        letter: "A",
    },
    {
        label: "天鹿660M",
        value: 'TC660M',
        letter: "A",
    },
    {
        label: "天鹿670M",
        value: 'TC670M',
        letter: "A",
    },
    {
        label: "天鹿680M",
        value: 'TC680M',
        letter: "A",
    },
    {
        label: "天鹿690M",
        value: 'TC690M',
        letter: "A",
    },
];

const TC700LIST = [
    {
        label: "天鹿710S",
        value: 'TC710S',
        letter: "B",
    },
    {
        label: "天鹿720S",
        value: 'TC720S',
        letter: "B",
    },
    {
        label: "天鹿730S",
        value: 'TC730S',
        letter: "B",
    },
    {
        label: "天鹿750S",
        value: 'TC750S',
        letter: "B",
    },
    {
        label: "天鹿760S",
        value: 'TC760S',
        letter: "B",
    },
    {
        label: "天鹿750M",
        value: 'TC750M',
        letter: "B",
    },
    {
        label: "天鹿760M",
        value: 'TC760M',
        letter: "B",
    },
    {
        label: "天鹿770M",
        value: 'TC770M',
        letter: "B",
    },
    {
        label: "天鹿780M",
        value: 'TC780M',
        letter: "B",
    },
    {
        label: "天鹿790M",
        value: 'TC790M',
        letter: "B",
    },
];

/**
 *  Lupus K-6000 系列：
    Lupus K-6900M/K-6800M/K-6700M/K-6600M
    Lupus K-6500S/K-6300S/K-6200S/K-6100S
    Lupus K-6200E/K-6100E
    Lupus 6000系列：
    Lupus 6900M/6800M/6700M/6600M
    Lupus 6500S/6300s/6200S/6100S
    Lupus 6200E/6100E
 * 
*/

const TP6000 = [
    // {
    //     label: "天狼6100E",
    //     value: "TP6100E",
    //     letter: "B",
    // },
    // {
    //     label: "天狼6200E",
    //     value: "TP6200E",
    //     letter: "B",
    // },
    // {
    //     label: "天狼6100S",
    //     value: "TP6100S",
    //     letter: "B",
    // },
    // {
    //     label: "天狼6200S",
    //     value: "TP6200S",
    //     letter: "B",
    // },
    // {
    //     label: "天狼6300s",
    //     value: "TP6300s",
    //     letter: "B",
    // },
    {
        label: "天狼6500S",
        value: "TP6500S",
        letter: "B",
    },
    // {
    //     label: "天狼6600M",
    //     value: "TP6600M",
    //     letter: "B",
    // },
    // {
    //     label: "天狼6700M",
    //     value: "TP6700M",
    //     letter: "B",
    // },
    // {
    //     label: "天狼6800M",
    //     value: "TP6800M",
    //     letter: "B",
    // },
    {
        label: "天狼6900M",
        value: "TP6900M",
        letter: "B",
    },
]

const TLGP = [
    {
        label: "天狼6500S",
        value: "TPGP6500S",
        letter: "B",
    },
    {
        label: "天狼6900M",
        value: "TPGP6900M",
        letter: "B",
    },
]

const TPk6000 = [
    // {
    //     label: "天狼K-6100E",
    //     value: "TPK6100E",
    //     letter: "A",
    // },
    // {
    //     label: "天狼K-6200E",
    //     value: "TPK6200E",
    //     letter: "A",
    // },
    // {
    //     label: "天狼K-6100S",
    //     value: "TPK6100S",
    //     letter: "A",
    // },
    // {
    //     label: "天狼K-6200S",
    //     value: "TPK6200S",
    //     letter: "A",
    // },
    // {
    //     label: "天狼K-6300S",
    //     value: "TPK6300S",
    //     letter: "A",
    // },
    {
        label: "天狼K-6500S",
        value: "TPK6500S",
        letter: "A",
    },
    // {
    //     label: "天狼K-6600M",
    //     value: "TPK6600M",
    //     letter: "A",
    // },
    // {
    //     label: "天狼K-6700M",
    //     value: "TPK6700M",
    //     letter: "A",
    // },
    // {
    //     label: "天狼K-6800M",
    //     value: "TPK6800M",
    //     letter: "A",
    // },
    // {
    //     label: "天狼K-6900M",
    //     value: "TPK6900M",
    //     letter: "A",
    // },
]

const TN500list = [
    {
        label: "天牛550S",
        value: "TN550S",
        letter: "A",
    },
    {
        label: "天牛530S",
        value: "TN530S",
        letter: "A",
    },
    {
        label: "天牛520S",
        value: "TN520S",
        letter: "A",
    },
    {
        label: "天牛570M",
        value: "TN570M",
        letter: "A",
    },
    {
        label: "天牛580M",
        value: "TN580M",
        letter: "A",
    },
    {
        label: "天牛590M",
        value: "TN590M",
        letter: "A",
    },
]

const TQ3000LIST = [
    {
        label: "天琴3500S",
        value: "TQ3500S",
        letter: "A",
    },
    {
        label: "天琴3300S",
        value: "TQ3300S",
        letter: "A",
    },
    {
        label: "天琴3200S",
        value: "TQ3200S",
        letter: "A",
    },
    {
        label: "天琴3700M",
        value: "TQ3700M",
        letter: "A",
    },
    {
        label: "天琴3800M",
        value: "TQ3800M",
        letter: "A",
    },
    {
        label: "天琴3900M",
        value: "TQ3900M",
        letter: "A",
    },
    {
        label: "天琴3600E",
        value: "TQ3600E",
        letter: "A",
    },
    {
        label: "天琴3300E",
        value: "TQ3300E",
        letter: "A",
    },
    {
        label: "天琴3100E",
        value: "TQ3100E",
        letter: "A",
    },
]

const TR200LIST = [
    {
        label: "天牛260M",
        value: "TR260M",
        letter: "A",
    },
    {
        label: "天牛210S",
        value: "TR210S",
        letter: "A",
    },
]


const TMLIST = [
    {
        label: "天猫100系列",
        value: "LYnx100",
        letter: "A",
    },
    {
        label: "天猫130系列",
        value: "LYnx130",
        letter: "A",
    }
]

export const machineTypeOption = [
    {
        label: "激光治疗仪",
        value: "YAG",
        type: "BP",
    },
    {
        label: "EYESPA",
        value: "EYESPA",
        type: "EYE",
    },
    {
        label: "天鸽/筛查箱",
        value: "COLUMBA",
        type: "SCX",
    },
    {
        label: '天鹅600系列',
        value: 'SWAN600',
        type: "TE",
    }, {
        label: "天鹅600P系列",
        value: "SWAN600P",
        type: "TE",
    }, {
        label: '天鹅700系列',
        value: 'SWAN700',
        type: "TE",
    }, {
        label: "天鹅700P系列",
        value: "SWAN700P",
        type: "TE",
    }, {
        label: '天龙900系列',
        value: 'TD',
        type: "TD",
    }, {
        label: "天龙800系列",
        value: "TL",
        type: "TL",
    }, {
        label: "天鹤700系列",
        value: "TH",
        type: "TE",
    }, {
        label: '星豚',
        value: 'STARTON',
        type: "XT",
    },
    {
        label: '星豚（新）',
        value: 'STARTONNEW',
        type: "XT",
    },
    {
        label: '天鹰600系列',
        value: 'TY600',
        type: "TY"
    }, {
        label: '天鹰700系列',
        value: 'TY700',
        type: "TY"
    },
    {
        label: '天鹿600系列',
        value: 'TC600',
        type: "TC"
    },
    {
        label: '天鹿700系列',
        value: 'TC700',
        type: "TC"
    }, {
        label: '天猫100系列',
        value: 'TM',
        type: "TM"
    }, {
        label: "天狼6000系列",
        value: 'TP6000',
        type: "TP"
    }, {
        label: "天狼K-6000系列",
        value: 'TPk6000',
        type: "TP"
    }, {
        label: "天狼海外（欧盟）系列",
        value: 'TPI6000',
        type: "TP"
    },
    {
        label: "天狼高配",
        value: "TLGP",
        letter: "TLGP",
    },
    {
        label: "天牛500系列",
        value: 'TN500',
        type: "TN"
    },
    {
        label: "视力表箱200系列",
        value: 'TR200',
        type: "TR"
    },
    {
        label: "天琴3000系列",
        value: 'TQ3000',
        type: "TQ"
    },
    // {
    //     label: "蓝鲸",
    //     value: 'LW',
    //     type: "LW",
    // }
];

export const starton = [
    {
        label: "星豚220",
        value: 'XT220',
        letter: "A",
    },
    {
        label: "星豚230",
        value: 'XT230',
        letter: "A",
    },
    {
        label: "星豚260",
        value: 'XT260',
        letter: "A",
    },
    {
        label: "星豚270",
        value: 'XT270',
        letter: "A",
    },
]



export const startonNew = [
    {
        label: "星豚210E",
        value: 'XT210E',
        letter: "A",
    },
    {
        label: "星豚220E",
        value: 'XT220E',
        letter: "A",
    },
    {
        label: "星豚230E",
        value: 'XT230E',
        letter: "A",
    },
    {
        label: "星豚220S",
        value: 'XT220S',
        letter: "A",
    },
    {
        label: "星豚230S",
        value: 'XT230S',
        letter: "A",
    },
    {
        label: "星豚260S",
        value: 'XT260S',
        letter: "A",
    },
    {
        label: "星豚270M",
        value: 'XT270M',
        letter: "A",
    },
    {
        label: "星豚280M",
        value: 'XT280M',
        letter: "A",
    },
    {
        label: "星豚290M",
        value: 'XT290M',
        letter: "A",
    },
]

const TPI6000 = [
    { label: '6500IS', value: 'TP6500IS', letter: 'A' },
    { label: '6300IS', value: 'TP6300IS', letter: 'A' },
    { label: '6200IS', value: 'TP6200IS', letter: 'A' },
    { label: '6900IM', value: 'TP6900IM', letter: 'A' },
    { label: '6800IM', value: 'TP6800IM', letter: 'A' },
    { label: '6700IM', value: 'TP6700IM', letter: 'A' },
    { label: '6100IE', value: 'TP6100IE', letter: 'A' },
    { label: '6000I', value: 'TP6000I', letter: 'A' },
];

export const machineOption = {
    COLUMBA: COLUMBAList,
    SWAN: SWANList,
    TD: TD900List,
    TL: TL800list,
    SWAN600: swan600List,
    SWAN600P: swan600PList,
    SWAN700: swan700List,
    SWAN700P: swan700PList,
    YAG: YAGList,
    EYESPA: EYESPAList,
    TH: TH700LIST,
    STARTON: starton,
    STARTONNEW: startonNew,
    TM: TMLIST,
    TY600: TY600LIST,
    TY700: TY700LIST,
    TC600: TC600LIST,
    TC700: TC700LIST,
    TP6000: TP6000,
    TPk6000: TPk6000,
    TPI6000: TPI6000,
    TLGP: TLGP,
    LW: LanWList,
    TN500: TN500list,
    TR200: TR200LIST,
    TQ3000: TQ3000LIST,
};

export const useMachineSelect = () => {
    const machieType = ref();

    const machineInfo = reactive({
        letter: null,
        model: null,
    });

    const updateMachineType = (e) => {
        machieType.value = e
    };

    const updateMachineInfo = (value, selectOption) => {
        machineInfo.letter = null;
        machineInfo.model = null;
        if (selectOption) {
            machineInfo.letter = selectOption.letter;
            machineInfo.model = selectOption.value;
        }
    };

    return {
        machieType,
        machineInfo,
        updateMachineType,
        updateMachineInfo,
    };
};
